import React from 'react';
import {Button as TempoButton, type ButtonProps} from '@tempo/core';

const Button: React.FC<ButtonProps> = React.forwardRef<
	HTMLButtonElement,
	ButtonProps
>(({children, ...props}, ref) => (
	<TempoButton variant="contain" size="medium" ref={ref} {...props}>
		{children}
	</TempoButton>
));

Button.displayName = 'Empty.Button';

export default Button;
